// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Close20Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Close20: FC<Close20Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="20"
            height="20"
        >
            <path d="M6.063 15 5 13.937 8.938 10 5 6.062 6.063 5 10 8.938 13.938 5 15 6.063 11.062 10 15 13.938 13.937 15 10 11.062 6.062 15Z" />
        </svg>
    );
};

export default Close20;
